import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { TeamsTableDefinitionZod } from '../tables';

type Arguments = {
    // only honoured for admins, everybody else gets the own corporation
    corporationId?: string;
    includeDeactivated?: boolean;
    position?: number;
};

export const schemaTeamResolver_ListByCorporation = z.array(TeamsTableDefinitionZod);

export type SchemaTeamResolver_ListByCorporation = z.infer<typeof schemaTeamResolver_ListByCorporation>;

export type TeamResolver_ListByCorporation = Resolver<Arguments, SchemaTeamResolver_ListByCorporation>;
